// Kept apart from content.js, which imports images and so cannot be read by the
// post-build SEO step. These answers are the source for both the FAQ section and
// the FAQPage structured data, so they only have to be written once.

export const FAQ_ITEMS = [
  {
    question: 'What is Warm?',
    answer:
      'Warm is a co-op winter survival game for PC. You keep one fire alive, forage wood, and try not to freeze or get dragged off by wolves. Each night gets harder. Solo or up to four players on Steam.',
  },
  {
    question: 'Can I play Warm on my own?',
    answer: 'Yes. Solo mode runs offline. No lobby, no internet.',
  },
  {
    question: 'How does co-op work?',
    answer:
      'Up to four players over Steam. Join a public lobby or open a private room for friends. Voice chat is built in if you want it.',
  },
  {
    question: 'What do I need?',
    answer: 'A Windows PC and Steam. Keyboard and mouse or a controller.',
  },
  {
    question: 'How do I send feedback?',
    answer: 'Use the Feedback button in the game, or the form on this site.',
  },
];
